import { render } from "./TransactionHistory.vue?vue&type=template&id=7c656f19&scoped=true"
import script from "./TransactionHistory.vue?vue&type=script&lang=js"
export * from "./TransactionHistory.vue?vue&type=script&lang=js"

import "./TransactionHistory.vue?vue&type=style&index=0&id=7c656f19&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c656f19"]])

export default __exports__